import React, { useEffect } from 'react';
import './MessageNotification.css';
import {
  setNotificationVisibility,
  showSystemVersionUploadNotification,
  showUpdateMachineVersionNotification,
} from '../../modules/actions/action';
import { connect } from 'react-redux';

const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="#dcfce7" stroke="#22c55e" strokeWidth="1.5" />
    <path d="M8 12.2 10.8 15 16 9.8" fill="none" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M8 8l8 8M16 8l-8 8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const MessageNotification = (props) => {
  const machineCount = props.selectedMachineCount || 0;

  const handleDismiss = () => {
    props.closeNotification();
    props.closeMachineUpdateNotification();
    props.closeSystemVersionUploadNotification();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      props.closeNotification();
      props.closeMachineUpdateNotification();
      props.closeSystemVersionUploadNotification();
    }, 8000);

    return () => clearTimeout(timer);
  }, [props.closeNotification, props.closeMachineUpdateNotification, props.closeSystemVersionUploadNotification]);

  const getMessage = () => {
    if (props.variant === 'systemVersionUpload') {
      return {
        title: 'Upload successful',
        description: 'Software version and OS version were uploaded successfully.',
      };
    }

    if (props.variant === 'machineUpdate') {
      return {
        title: 'Update sent successfully',
        description: machineCount > 0
          ? `The selected version was sent to ${machineCount} machine${machineCount === 1 ? '' : 's'}.`
          : 'The selected version was sent to the machine(s).',
      };
    }

    return {
      title: 'Update sent successfully',
      description: props.systemVersion
        ? `System version ${props.systemVersion} was shared with the machine successfully.`
        : 'System version was shared with the machine successfully.',
    };
  };

  const { title, description } = getMessage();

  return (
    <div className="app-toast app-toast--success" role="status" aria-live="polite">
      <span className="app-toast-icon">
        <SuccessIcon />
      </span>

      <div className="app-toast-content">
        <p className="app-toast-title">{title}</p>
        <p className="app-toast-description">{description}</p>
      </div>

      <button
        type="button"
        className="app-toast-close"
        onClick={handleDismiss}
        aria-label="Dismiss notification"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedMachineCount: state.selectMachineToUpdateVersion?.selectedMachineToUpdateVersion?.length || 0,
});

const mapDispatchToProps = (dispatch) => ({
  closeNotification: () => { dispatch(setNotificationVisibility(false)); },
  closeMachineUpdateNotification: () => { dispatch(showUpdateMachineVersionNotification(false)); },
  closeSystemVersionUploadNotification: () => { dispatch(showSystemVersionUploadNotification(false)); },
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageNotification);
